import { GlobalSettings } from "../global-settings/global-settings.service";
import { ClientDomain } from "../product-capture/product-capture-details/overview/documents-tab/request-modal/request-modal.consts";

export class ClientUtils {

    static getClientFromHostname(): string {
        const [ _, client ] = location.hostname.match(/(?:[^.]+\.)?([^.]+\.[^.]+\.[^.]+)(\/.*)?$/) ?? [];
        return client;
    }

    static isClient(client: ClientDomain): boolean {
        if (client === ClientDomain.DeutscheBank) {
            return GlobalSettings.getAppSettings().userPreferences?.userSettings?.emulateDBEnviroment || this.getClientFromHostname() === ClientDomain.DeutscheBank;
        }
        return  this.getClientFromHostname() === client;
    }
}